import React, { useState, useEffect } from 'react';
import {UUIDUtil} from "@aperza/util";
import useReactiveMessage from '../hook/UseReactiveMessage';

const useCatalogItemListener = (className = 'catalogPreview') => {

  const [catalog, setCatalog] = useState(undefined);
  const {getMessage} = useReactiveMessage('CATALOG_PREVIEW');
  let subscription;

  const onClickPreview = (event) => {
    let source = event.currentTarget;
    if (source) {
       let parent = source.parentElement;
      if ($(parent).hasClass('m_previewBtn')) {
        parent = parent.parentElement;
      }

      let superParent = parent.parentElement;

      let previewEl = $(superParent);
      let title = previewEl.find('.catalogTitleLink').text().trim();
      let subtitle = previewEl.find('[name="catalogSubtitle"]').val();
      let description = previewEl.find('[name="catalogDescription"]').val();
      let type = previewEl.find('[name="catalogDocumentTypeLabel"]').val();
      let brandName = previewEl.find('.catalogCompanyLink').text().trim();
      let brandImageUrl = previewEl.find('[name=catalogCompanyLogoUrl]').val();
      let fileSize = previewEl.find('[name="catalogDocumentSizeBytes"]').val();
      let catalogPageUrl = previewEl.find('[name="catalogPageUrl"]').val();

      let pages = [];
      for (let i=1;i<=3;i++) {
        let catalogImage = previewEl.find(`[name="catalogImage${i}"]`).val();
        if (catalogImage) {
          pages.push({imageUrl: catalogImage})
        }
      }

      let downloadButtonEl = $(superParent).find('.catalogDownloadLink')[0];

      setCatalog({
        title,
        subtitle,
        description,
        type,
        brandName,
        brandImageUrl,
        fileSize,
        catalogPageUrl,
        pages,
        companyId: parseInt(downloadButtonEl.dataset.company_id),
        catalogId: parseInt(downloadButtonEl.dataset.catalog_id),
        companyContractDisplayId: parseInt(downloadButtonEl.dataset.company_contract_display_id),
        documentId: downloadButtonEl.dataset.document_id,
        clickedAt: new Date().getTime(),
      })

    }

  };

  useEffect(() => {
    subscription = getMessage().subscribe(message => {
      if (message) {
        setCatalog({
          requestId: UUIDUtil.uuid(),
          title: message.title,
          subtitle: message.subtitle,
          description: message.description,
          type: message.tags.length > 0? message.tags[0]:'',
          brandName: message.companyName,
          brandImageUrl: message.companyLogoUrl,
          //companyPageUrl: message.companyPageUrl,
          fileSize: ''+message.fileSize,
          catalogPageUrl: message.catalogPageUrl,
          pages: message.catalogPreviewImageUrls.map(url => {return {imageUrl: url}}),
          companyId: message.companyId,
          catalogId: message.catalogId,
          companyContractDisplayId: message.companyContractDisplayId,
          clickedAt: new Date().getTime(),
        });
      }
    });


    let elements = document.getElementsByClassName(className);
    elements.forEach(el => {
      el.addEventListener('click', (event) => {
        if (event) onClickPreview(event);
      })
    })
  }, []);

  return { catalog };
};

export default useCatalogItemListener;
